import buildClickoutEvent from "../buildClickoutEvent";
import sendEvents from "../sendEvents";

export default function trackByCategoryEvent(element: HTMLElement, eventCategory: "donation") {
  const Event = buildClickoutEvent(element);

  Event.type = eventCategory;
  sendEvents(Event);
}
